<tr *ngFor="let row of rowList" class="lc-skeleton-row" [attr.aria-hidden]="true">
  <td *ngFor="let col of colList; let ci = index">
    <span
      class="lc-skeleton-line"
      [style.width.%]="lineWidth(ci)"
      [style.animation-delay.ms]="row * 60 + ci * 40"
    ></span>
  </td>
</tr>
